import BillingCode from "../../../../pages/Config/BillingCode";
import BillingCodeNewEdit from "../../../../pages/Config/BillingCode/NewEdit";

const routerBillingCode = [
    {
        key: "billing-codes",
        path: "/config/billing-codes",
        element: <BillingCode />,
    },
    {
        key: "billing-codes-new",
        path: "/config/billing-codes/new",
        element: <BillingCodeNewEdit />,
    },
    {
        key: "billing-codes-detail",
        path: "/config/billing-codes/:id",
        element: <BillingCodeNewEdit />,
    },
]

export default routerBillingCode
